export const FEATURES_RETAIL_VALUE_VARIANT = {
	message: 'message',
	tooltip: 'tooltip',
} as const;
